/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import UsageTracker from '../utils/UsageTracker';
import { SCREENS } from '../constants/Tracking';
// @ts-expect-error Could not find a declaration file for module
import { useFetchTracksLessonsData } from '../hooks/catalogPageHooks';
import FeaturedSoftwareCoursesSection from '../components/FeaturedSoftwareCoursesSection/FeaturedSoftwareCoursesSection';
import HomePageLayout from '../components/Layouts/HomePageLayout';
import { jsx as _jsx } from "react/jsx-runtime";
const Homepage = () => {
  const hasError = useSelector(state => state.tracks.get('hasError'));
  const recentError = useSelector(state => state.tracks.get('recentError'));
  useFetchTracksLessonsData();
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: SCREENS.HOME
    });
  }, []);
  return /*#__PURE__*/_jsx(HomePageLayout, {
    error: hasError ? recentError : null,
    footerComponent: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FeaturedSoftwareCoursesSection, {})
    })
  });
};
export default Homepage;